import React, { useState } from 'react';
import { Box, TextField, IconButton, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { db, auth } from '../../firebase'; // Ensure correct path
import { doc, setDoc } from 'firebase/firestore'; // Changed from updateDoc to setDoc for merging capability

function PersonalData(props) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  // Function to save first and last name to Firestore, creating the document if it doesn't exist
  const saveDataToFirestore = async () => {
    // Check if there is a currently authenticated user
    if (auth.currentUser) {
      const uid = auth.currentUser.uid; // Get current user's UID
      const userRef = doc(db, 'users', uid); // Reference to the user's document in Firestore

      try {
        // Use setDoc with merge:true to create the document if it doesn't exist or update it if it does
        await setDoc(userRef, {
          firstName: firstName,
          lastName: lastName,
        }, { merge: true });
        console.log('Data saved successfully');
        props.onNext(); // Proceed to the next step if save is successful
      } catch (error) {
        console.error('Error saving data to Firestore', error);
      }
    } else {
      console.error('No authenticated user found');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        width: '100%',
        margin: 'auto',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: '10px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          padding: '50px',
          width: '50%',
          height: '50vh',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Typography variant="h5" sx={{ width: '100%', textAlign: 'left', marginBottom: '50px', fontWeight: 'bold' }}>
            Tell us about yourself...
          </Typography>
          <Typography variant="h6" sx={{ marginBottom: '20px', fontWeight: 'bold'}}>
            What is your <span style={{ color: '#ff4c15ff' }}>first</span> name?
          </Typography>
          <TextField
            variant="outlined"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            fullWidth
            placeholder='Marco'
            InputLabelProps={{
              style: { color: '#ff4c15ff' },
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F5F5F5',
                  marginBottom: '20px',
                  '& fieldset': {
                    borderColor: 'transparent',
                  },
                  '&:hover fieldset': {
                    borderColor: 'transparent',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'transparent',
                  },
                },
              }}
          />
          <Typography variant="h6" sx={{ marginBottom: '20px', fontWeight: 'bold' }}>
            What is your <span style={{ color: '#ff4c15ff' }}>last</span> name?
          </Typography>
          <TextField
            variant="outlined"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            fullWidth
            placeholder='Polo'
            InputLabelProps={{
              style: { color: '#ff4c15ff' },
            }}
            sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F5F5F5',
                  '& fieldset': {
                    marginBottom: '20px',
                    borderColor: 'transparent',
                  },
                  '&:hover fieldset': {
                    borderColor: 'transparent',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'transparent',
                  },
                },
              }}
          />
        </Box>
        <IconButton
          aria-label="next"
          onClick={saveDataToFirestore} // Invoke saveDataToFirestore when the next button is clicked
          sx={{
            backgroundColor: '#ff4c15ff',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#e2400f',
            },
            borderRadius: '10px',
            marginTop: '50px',
            position: 'absolute',
            bottom: 50,
            right: 50,
            width: '50px',
            height: '50px'
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

export default PersonalData;
